module.exports = __webpack_public_path__ + "static/media/tiny-manual-import-2.c2d063ab.png";